import React from "react";
import PropTypes from "prop-types";
import { ModalClosed } from "~misc/icons";
import { Link } from "react-router-dom";

const Modal = ({
  isOpen,
  onClose,
  title,
  sub,
  buttonOne,
  buttonTwo,
  linkOne,
  linkTwo,
  hideButtonOne,
  hideButtonTwo,
  buttonOneColor,
  buttonTwoColor,
  className,
}) => {
  const modalClasses = isOpen ? `fixed inset-0 bg-black bg-opacity-50 z-[999999]` : "hidden";
  const overlayClasses = isOpen ? `fixed inset-0 bg-black opacity-50 z-40` : "hidden";

  return (
    <div className={modalClasses} data-testid="modal-overlay">
      <div className="fixed inset-0 flex items-center justify-center z-50">
        <div
          className={`bg-white px-14 py-14 rounded-[20px] shadow-lg z-50 text-center relative ${className ?? ""}`}
          data-testid="modal"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
              data-testid="close-button"
              aria-label="Fechar modal"
            >
              <ModalClosed />
            </button>
          </div>
          <h3 className="font-bold text-4xl max-w-[400px]">{title}</h3>
          <div className="mt-2" data-testid="modal-content">
            {sub}
          </div>
          <div className="flex justify-center gap-3 mt-3 buttons-row" data-testid="modal-buttons">
            {!hideButtonOne && (
              <Link
                to={linkOne && typeof linkOne === "string" ? linkOne : "#"}
                onClick={(e) => {
                  if (linkOne && typeof linkOne === "function") {
                    e.preventDefault();
                    linkOne();
                  }
                }}
              >
                <button
                  type="button"
                  className={`px-6 py-3 rounded ${
                    buttonOneColor ? `!bg-[${buttonOneColor}]` : ""
                  } bg-secundaria text-primaria font-bold  hover:bg-white hover:text-secundaria border-2 border-secundaria border-quartenaria transition duration-300 ease-in-out`}
                  data-testid="button-one"
                >
                  {buttonOne}
                </button>
              </Link>
            )}
            {!hideButtonTwo && (
              <Link
                to={linkTwo && typeof linkTwo === "string" ? linkTwo : "#"}
                onClick={(e) => {
                  if (linkTwo && typeof linkTwo === "function") {
                    e.preventDefault();
                    linkTwo();
                  }
                }}
              >
                <button
                  type="button"
                  className={`px-6 py-3 rounded border-2 ${
                    buttonTwoColor ? `!bg-[${buttonOneColor}]` : ""
                  } border-quinaria  text-quinaria font-bold hover:bg-quinaria hover:text-white transition duration-300 ease-in-out `}
                  data-testid="button-two"
                >
                  {buttonTwo}
                </button>
              </Link>
            )}
          </div>
        </div>
        <div className={overlayClasses} onClick={onClose}></div>
      </div>
    </div>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  sub: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  buttonOne: PropTypes.string,
  buttonTwo: PropTypes.string,
  linkOne: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  linkTwo: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  hideButtonOne: PropTypes.bool,
  hideButtonTwo: PropTypes.bool,
  buttonOneColor: PropTypes.string,
  buttonTwoColor: PropTypes.string,
  className: PropTypes.string,
};

export default Modal;
